import FalconCardHeader from 'components/common/FalconCardHeader';
import { useAuth } from 'context/AuthContext';
import { updateUser } from 'helpers/access';
import React, { useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

const ChangePassword = () => {
  const { t } = useTranslation();
  const { userData } = useAuth();
  const [formData, setFormData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [isSaving, setIsSaving] = useState(false);

  const handleChange = event => {
    setFormData(currentState => ({
      ...currentState,
      [event.target.name]: event.target.value
    }));
  };

  const handleSubmit = async event => {
    event.preventDefault();

    if (formData.newPassword !== formData.confirmPassword) {
      toast.error(t('USER_SETTINGS.ERRORS.PASSWORD_MISMATCH'), {
        theme: 'colored'
      });
      return;
    }

    const membershipId = userData?.membership?.id;
    if (!membershipId) {
      toast.error(t('USER_SETTINGS.ERRORS.PASSWORD_SAVE'), {
        theme: 'colored'
      });
      return;
    }

    setIsSaving(true);
    try {
      await updateUser(membershipId, {
        password: formData.newPassword
      });

      setFormData({
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      });

      toast.success(t('USER_SETTINGS.TOASTS.PASSWORD_SAVED'), {
        theme: 'colored'
      });
    } catch (requestError) {
      console.error(requestError);
      toast.error(
        requestError.response?.data?.error || t('USER_SETTINGS.ERRORS.PASSWORD_SAVE'),
        { theme: 'colored' }
      );
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Card className="mb-3">
      <FalconCardHeader title={t('USER_SETTINGS.SECURITY.TITLE')} />
      <Card.Body className="bg-light">
        <p className="text-600 mb-4">{t('USER_SETTINGS.SECURITY.DESCRIPTION')}</p>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="oldPassword">
            <Form.Label>{t('USER_SETTINGS.FIELDS.CURRENT_PASSWORD')}</Form.Label>
            <Form.Control
              type="password"
              value={formData.oldPassword}
              name="oldPassword"
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="newPassword">
            <Form.Label>{t('USER_SETTINGS.FIELDS.NEW_PASSWORD')}</Form.Label>
            <Form.Control
              type="password"
              value={formData.newPassword}
              name="newPassword"
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="confirmPassword">
            <Form.Label>{t('USER_SETTINGS.FIELDS.CONFIRM_PASSWORD')}</Form.Label>
            <Form.Control
              type="password"
              value={formData.confirmPassword}
              name="confirmPassword"
              onChange={handleChange}
            />
          </Form.Group>
          <Button className="w-100" type="submit" disabled={isSaving}>
            {isSaving
              ? t('USER_SETTINGS.ACTIONS.SAVING')
              : t('USER_SETTINGS.ACTIONS.SAVE_PASSWORD')}
          </Button>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default ChangePassword;
